// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ee492ee0","796":"5eba23e9"}[chunkId] + ".chunk.js";
};